import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import {  productSlide1 } from "../../constant";
// import { ImageUrl } from "../../network/ApiUrl";

function ProductDetailSlider(props) {
//   const { ParamData } = props;
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const ParamData = [
    {
      id: 1,
      img: productSlide1,
    },
    {
      id: 2,
      img: productSlide1,
    },
    {
      id: 3,
      img: productSlide1,
    },
    {
      id: 4,
      img: productSlide1,
    },
  ];

  return (
    <>
      <div className="product-slide">
        <Slider asNavFor={nav2} ref={slider1} arrows={false}>
        {ParamData?.map((item, index) => {
            console.log(item);
            return (
              <div className="product-images mainimage-container" key={index}>
                <figure>
                  <img
                    src={item?.img}
                    alt=""
                    className="image-fluid image-width"
                  />
                </figure>
              </div>
            );
          })}
        </Slider>

        <Slider
          asNavFor={nav1}
          ref={slider2}
          slidesToShow={4}
          swipeToSlide={true}
          focusOnSelect={true}
          arrows={true}
          className="slick-custom"
        >
          {ParamData?.map((item, index) => {
            console.log(item);
            return (
              <div className="inner-image-container" key={index}>
                <figure>
                <img
                    src={item?.img}
                    alt=""
                    className="image-fluid image-width"
                  />
                </figure>
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
}

export default ProductDetailSlider;
